import Spinner from 'react-bootstrap/Spinner';

export const LoadingSpinner = () => {
  return <Spinner animation="border" variant="secondary" />;
};
